import { takeLatest, put, select, call } from 'redux-saga/effects';
import {
    GET_ACTIVE_SERVICES_REQUEST,
    getActiveServicesSuccess,
    getActiveServicesFailure,
} from '../actions/active';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { getActiveServices } from '../services/activeServices';

let continueWhileWebsocket = true;

const getActiveServicesWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
       

        const response = yield call(getActiveServices, filters, token);

        const {
            data: { activeservices, total } 
        } = response;

        yield put(getActiveServicesSuccess(activeservices, total));
    } catch (err) {
        yield put(getActiveServicesFailure(err));
        yield put(showGlobalError(true, err));
    }
};


export default [
    takeLatest(GET_ACTIVE_SERVICES_REQUEST, getActiveServicesWorker),
];
